/* projects/shared/layouts/responsive-layout/responsive-layout.component.scss */
responsive-layout .canvas {
  display: grid;
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
  grid-template-rows: max-content 1fr;
  overflow: hidden;
  gap: var(--space-s);
}
@media screen and (max-width: 767px) {
  responsive-layout .canvas {
    gap: 0;
  }
}
responsive-layout .canvas:has(.side-nav-layout) {
  background-color: var(--color-app-default-bg);
}
responsive-layout .canvas:has(.top-nav-closed) {
  background-color: var(--color-white);
}
responsive-layout .canvas:has(.top-nav-opened) {
  background-color: var(--color-white);
}
responsive-layout .nav-bar {
  grid-area: nav;
  background-color: var(--color-blue);
  color: var(--color-white);
  display: grid;
  overflow: auto;
}
responsive-layout .mat-tree {
  background-color: var(--color-blue);
}
responsive-layout .outlet-wrapper {
  grid-area: outlet;
  overflow-y: hidden;
  overflow-x: hidden;
}
responsive-layout footer {
  grid-area: footer;
  width: 100%;
}
responsive-layout .side-nav-layout {
  display: none;
}
@media screen and (min-width: 768px) {
  responsive-layout .side-nav-layout {
    display: grid;
    grid-template-areas: "nav outlet" "footer footer";
    grid-template-columns: var(--responsive-navbar-on-the-side-item-width) 1fr;
    grid-template-rows: 1fr max-content;
    gap: var(--space-s) var(--space-m);
    padding: 0px var(--space-m) var(--space-s);
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  responsive-layout .side-nav-layout .nav-bar {
    border-radius: var(--space-m);
  }
}
responsive-layout .top-nav-layout {
  display: grid;
  grid-template-areas: "nav" "outlet" "footer";
  height: 100%;
  width: 100%;
  overflow: hidden;
}
responsive-layout .top-nav-layout.top-nav-closed {
  grid-template-rows: var(--responsive-navbar-on-the-top-item-height) 1fr max-content;
}
responsive-layout .top-nav-layout.top-nav-closed .outlet-wrapper {
  visibility: visible;
  display: initial;
}
responsive-layout .top-nav-layout.top-nav-opened {
  grid-template-rows: 100%;
}
responsive-layout .top-nav-layout.top-nav-opened .outlet-wrapper {
  visibility: hidden;
  display: none;
}
responsive-layout .top-nav-layout.nav-hidden {
  grid-template-rows: var(--responsive-navbar-on-the-top-item-height) 1fr max-content;
}
responsive-layout .top-nav-layout.nav-hidden .outlet-wrapper {
  visibility: visible;
  display: grid;
  place-items: center;
}
responsive-layout .nav-hidden {
  display: grid;
  place-items: center;
  grid-template-areas: "outlet" "footer";
  grid-template-rows: 1fr max-content;
  gap: var(--space-s) var(--space-m);
  padding: 0px var(--space-m) var(--space-s);
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
/*# sourceMappingURL=responsive-layout.component-DYNUXDPX.css.map */
